var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"header":_vm.header,"methods":_vm.methods,"modals":_vm.modals,"config":_vm.config},scopedSlots:_vm._u([{key:"ADDMODAL",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
var close = ref.close;
return [(visible)?_c('AddModal',{attrs:{"isBank":params.isBank,"close":close,"selectData":_vm.selectData,"row":params}}):_vm._e()]}},{key:"Freight",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
var close = ref.close;
return [(visible)?_c('ClientFreight',{attrs:{"close":close,"rows":params}}):_vm._e()]}},{key:"robot",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
var close = ref.close;
return [(visible)?_c('robot',{attrs:{"close":close,"rows":params}}):_vm._e()]}},{key:"Contract",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
var close = ref.close;
return [(visible)?_c('ClientContract',{ref:"contract",attrs:{"close":close,"clientId":params.id,"clientName":params.account,"rows":params}}):_vm._e()]}},{key:"Whitelist",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
var close = ref.close;
return [(visible)?_c('ClientWhitelist',{attrs:{"close":close,"id":params.id}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }